<div class="">
  <div class="container-fluid">
    <div class="footer mt-0" style=" line-height: 0px; ">
      <div class="row">
        <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
          <footer class="page-footer font-small blue">
            <div class="footer-copyright" style=" line-height: normal;">
              <!--<b>Copyright © </b> <a style="color:#FF6600;" href="https://www.andica.com/" target="_blank"><b>Andica Limited {{year}}.</b></a> <b> All rights reserved.</b>-->
              <b>Copyright © </b> <a style="color:#FF6600;" href="https://www.andica.com/" target="_blank"><b>2004-{{Year}} Andica Limited.</b></a>
                                  <!--<a style="color:#FF6600;" href="https://www.andica.com/" target="_blank"><b>||</b></a>-->
                                  <!--<a style="color:#FF6600;" href="https://www.andica.com/" target="_blank"><b> Andica Limited.</b></a>-->
              <b> All rights reserved.</b>
            </div>
          </footer>
        </div>
        <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12  text-md-end text-start pt-md-2 pt-3">
          <!--<a href="javascript:void(0);">Privacy Policy</a>
  &middot;
  <a href="javascript:void(0);">Terms &amp; Conditions</a>-->
          <a href="https://www.andica.com/legal-software-licence-agreement.html" target="_blank">Licence Agreement</a>
          &middot;
          <a href="https://www.andica.com/legal.html" target="_blank">Legal Terms</a>
        </div>
       </div>
     </div>
   </div>
</div>
